<template>
    <div>
        <h5>Manage Users Group</h5>
        <div class="card">
            <!-- Users Selection Listing -->
            <div class="field">
                <div class="col-3">
                    <UsersPicker v-model="selectedUserId" />
                    <small class="p-invalid" v-if="submitted && !selectedUserId">Select atleast one user from the dropdown.</small>
                </div>
            </div>
            <!-- Groups Selection -->
            <div v-if="selectedUserId" class="field col-12">
                <label for="description">Select Groups for the User</label>
                <br /><small class="p-invalid" v-if="submitted && userGroups.length <= 0">Select atleast one group from the list.</small>
                <PickList v-model="groups" dataKey="id" :showSourceControls="false" showTargetControls="false">
                    <template #sourceheader> All Groups Available </template>
                    <template #targetheader> Added Groups List </template>
                    <template #item="slotProps">
                        <div>{{ slotProps.item.code }}</div>
                    </template>
                </PickList>
            </div>
            <div class="field col-3">
                <Button label="Add Groups To User" class="my-4" @click="addGroupsToUser"></Button>
            </div>
        </div>
    </div>
</template>

<script>
import UsersPicker from '../../../components/user/UsersPicker';

import GroupService from '@/services/group-service';
import UserService from '@/services/user-service';

import { mapGetters } from 'vuex';
export default {
    components: { UsersPicker },
    data() {
        return {
            params: {
                rows: null,
                page: null,
                paginate: null,
            },
            selectedUserId: null,
            userGroups: null,
            groups: null,
            submitted: false,
        };
    },
    groupService: null,
    userService: null,
    computed: {
        ...mapGetters('auth', ['userCompanyId']),
    },
    watch: {
        groups: {
            handler() {
                this.userGroups = this.groups[1].map(function (item) {
                    return item.id;
                });
            },
        },
        selectedUserId: {
            async handler() {
                if (this.selectedUserId) {
                    /** Load the user existing groups first and load them into the 2nd */
                    await this.loadUserGroups();
                    /** Then filter out with the existing groups from the all groups section */
                    this.groups[0] = await this.filterUserGroups();
                }
                this.loadUserGroups();
            },
        },
    },
    created() {
        this.groupService = new GroupService();
        this.userService = new UserService();
        this.loadGroups();
    },
    methods: {
        async loadGroups() {
            const groupParams = {
                paginate: false,
                company_id: this.userCompanyId.id,
            };
            await this.groupService.getAllGroups(groupParams).then((response) => {
                this.groups = [response.data, []];
            });
        },
        async loadUserGroups() {
            // In the api:- GET /v2/admin/user/{userId}/groups, the params says userId but its wrong, it takes user_id
            const userParams = {
                user_id: this.selectedUserId,
                company_id: this.userCompanyId.id,
            };
            await this.userService.getUserGroupsByUserId(userParams).then((response) => {
                this.groups[1] = response.data?.groups;
                this.userGroups = this.groups[1].map((item) => {
                    return item.id;
                });
            });
        },

        async filterUserGroups() {
            let arr1 = this.groups[0];
            let arr2 = this.groups[1];
            return arr1.filter((obj1) => !arr2.find((obj2) => obj1.id === obj2.id));
        },

        async addGroupsToUser() {
            this.submitted = true;
            if (this.validateUserGroupData()) {
                await this.userService.addUserToGroups(this.selectedUserId, this.userGroups, this.userCompanyId.id).then((data) => {
                    if (data.statusCode == 200) {
                        this.clearFields();
                        this.$emit('user-added-to-groups', true);
                        this.submitted = false;
                        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'User added to the Groups', life: 5000 });
                    } else {
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: data.message, life: 5000 });
                    }
                });
            }
        },
        validateUserGroupData() {
            if (!this.selectedUserId || this.userGroups.length <= 0) {
                return false;
            }
            return true;
        },
        clearFields() {
            this.selectedUserId = null;
            this.userGroups = null;
            this.loadGroups();
        },
    },
};
</script>
